//@flow
import * as React from 'react';
import classnames from 'classnames';
import theme from './Loader.scss';
import { themr } from 'react-css-themr';
import { ListCard } from 'common/components/core/card/ListCard';
import BackgroundColor from 'common/components/core/colors/background.scss';
import type { Color } from 'common/models/internal/Color';
import { SizeEnum } from 'common/enums/UIEnums';
import { dashboardColors } from 'common/enums/ColorEnum';

type Props = {
    active: boolean,
    theme: Object,
    withText?: boolean,
    title?: string,
    subtitle?: string,
    loaderColor?: Color,
    backgroundColor?: Color,
    size?: string,
    zIndex?: number,
    style?: { [key: string]: string | number }
};

class Loader extends React.PureComponent<Props, void> {
    render() {
        var {
            active,
            theme,
            withText,
            title,
            subtitle,
            loaderColor,
            solid,
            backgroundColor = solid && dashboardColors.white.name,
            className,
            absolute,
            relative,
            zIndex = 100,
            style,
            size
        } = this.props;
        const sizeClass = SizeEnum.getSizeClass({ theme, size });
        let backgroundColorClass = '';
        if (backgroundColor) {
            backgroundColorClass = BackgroundColor[backgroundColor.name];
        }
        let loaderColorClass;
        if (loaderColor) {
            loaderColorClass = theme[loaderColor.name];
        }
        return active ? (
            <div
                style={{ ...style, zIndex }}
                className={classnames(
                    theme.loaderWrap,
                    className,
                    backgroundColorClass,
                    {
                        [loaderColorClass]: !!loaderColorClass,
                        [sizeClass]: !!sizeClass,
                        [theme.absolute]: absolute,
                        [theme.relative]: relative
                    }
                )}
            >
                <div className={theme.loaderInner}>
                    <div className={theme.loaderCircle} />
                </div>
                {withText ? (
                    <div className={theme.textBlock}>
                        <ListCard
                            theme={theme}
                            title={title}
                            subtitle={subtitle}
                        />
                    </div>
                ) : null}
            </div>
        ) : null;
    }
}

const ThemedLoader = themr('Loader', theme)(Loader);

export default ThemedLoader;
export { ThemedLoader as Loader };
